import axios from "axios";
import Common from "../../componets/Common";

export const verificarExistenciaCIP = async (invoice, authPayment) => {
  const resCIPExistente = await axios.get(
    `${Common.urlAPI}/VerificarExistenciaCIP/${invoice}`,
    authPayment
  );

  return resCIPExistente
}
